import React from "react";
import SeguimientoMateriales from "./SeguimientoMateriales";

/** Seguimiento de habilitacion sobre el inventario por almacen. */
export default function ListadoSeguimientoHabilitacion() {
  return <SeguimientoMateriales tipo="Habilitacion" />;
}
